const grouper = new Intl.NumberFormat("en-US");

/** Groups an integer with thousands separators, e.g. 1240 -> "1,240". */
export function formatNumber(value: number): string {
  return grouper.format(Math.round(value));
}

/** Formats a money amount with a leading "$" and thousands grouping. */
export function formatMoney(value: number): string {
  return `$${formatNumber(value)}`;
}
